import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'am-bags-footer-resume',
    templateUrl: './am-bags-footer-resume.component.html',
    styleUrls: ['./am-bags-footer-resume.component.scss'],
    standalone: false
})
export class AmBagsFooterResumeComponent implements OnInit {

  @Input() totalBags: number = 0;

  constructor() { }

  ngOnInit() {
  }

}
